import { initApplication } from "@/app";
import { initTopMailRu } from "@/shared";

initTopMailRu();
initApplication();
